module.exports = __webpack_public_path__ + "static/social-card-e8072595863e260e0c62cd3d15e0b956.png";